export const CUSTOMER_ALREADY_EXISTS_PARAM = "CUSTOMER_ALREADY_EXISTS";
export const CUSTOMER_ALREADY_VALIDATED_PARAM = "CUSTOMER_ALREADY_VALIDATED";

export const PAYMENT_PARAM = "payment";
export const SUCCESS_VALUE = "success";
export const ERROR_VALUE = "error";
